import { formatDateTime } from "shared/utils/datetime";

const LogViewer = (props) => {
  const logRecords = props.LogRecords;
  const displaySize = props.displaySize || props.LogRecords.length;

  return (
    <div>
      {logRecords &&
        logRecords
          .slice(-displaySize)
          .reverse()
          .map((rc, idx) => {
            const time =
              typeof rc["Time"] === "number" ? new Date(rc["Time"]) : rc["Time"];
            return (
              <div key={logRecords.length - idx}>
                {"- "}
                {formatDateTime(time)}.
                {String(time.getMilliseconds()).padStart(3, "0")}
                : {rc["Message"]}
              </div>
            );
          })}
    </div>
  );
};

export default LogViewer;
